// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as VerifyEmailChangeRouteImport } from './routes/verify-email-change'
import { Route as TyndaleRouteImport } from './routes/tyndale'
import { Route as TrackRouteImport } from './routes/track'
import { Route as ShopRouteImport } from './routes/shop'
import { Route as ShippingRouteImport } from './routes/shipping'
import { Route as SaleRouteImport } from './routes/sale'
import { Route as ReturnsRouteImport } from './routes/returns'
import { Route as ResetPasswordRouteImport } from './routes/reset-password'
import { Route as RegisterRouteImport } from './routes/register'
import { Route as PrivateProductsRouteImport } from './routes/private-products'
import { Route as PrivacyPolicyRouteImport } from './routes/privacy-policy'
import { Route as LoginRouteImport } from './routes/login'
import { Route as LivingBooksRouteImport } from './routes/living-books'
import { Route as LifepacRouteImport } from './routes/lifepac'
import { Route as IntlShippingRouteImport } from './routes/intl-shipping'
import { Route as ForgotPasswordRouteImport } from './routes/forgot-password'
import { Route as FaqsRouteImport } from './routes/faqs'
import { Route as EnrichmentClassesRouteImport } from './routes/enrichment-classes'
import { Route as ContactRouteImport } from './routes/contact'
import { Route as CheckoutRouteImport } from './routes/checkout'
import { Route as CartRouteImport } from './routes/cart'
import { Route as BooklistRouteImport } from './routes/booklist'
import { Route as BjuRouteImport } from './routes/bju'
import { Route as AccountRouteImport } from './routes/account'
import { Route as AboutRouteImport } from './routes/about'
import { Route as IndexRouteImport } from './routes/index'
import { Route as PSlugRouteImport } from './routes/p.$slug'
import { Route as OrderReturnRouteImport } from './routes/order.return'
import { Route as OrderIdRouteImport } from './routes/order.$id'
import { Route as AccountIndexRouteImport } from './routes/account.index'
import { Route as AccountWishlistRouteImport } from './routes/account.wishlist'
import { Route as AccountProfileRouteImport } from './routes/account.profile'
import { Route as AccountOrdersRouteImport } from './routes/account.orders'
import { Route as AccountAddressesRouteImport } from './routes/account.addresses'

const VerifyEmailChangeRoute = VerifyEmailChangeRouteImport.update({
            id: '/verify-email-change',path: '/verify-email-change',getParentRoute: () => rootRouteImport
          })
const TyndaleRoute = TyndaleRouteImport.update({
            id: '/tyndale',path: '/tyndale',getParentRoute: () => rootRouteImport
          })
const TrackRoute = TrackRouteImport.update({
            id: '/track',path: '/track',getParentRoute: () => rootRouteImport
          })
const ShopRoute = ShopRouteImport.update({
            id: '/shop',path: '/shop',getParentRoute: () => rootRouteImport
          })
const ShippingRoute = ShippingRouteImport.update({
            id: '/shipping',path: '/shipping',getParentRoute: () => rootRouteImport
          })
const SaleRoute = SaleRouteImport.update({
            id: '/sale',path: '/sale',getParentRoute: () => rootRouteImport
          })
const ReturnsRoute = ReturnsRouteImport.update({
            id: '/returns',path: '/returns',getParentRoute: () => rootRouteImport
          })
const ResetPasswordRoute = ResetPasswordRouteImport.update({
            id: '/reset-password',path: '/reset-password',getParentRoute: () => rootRouteImport
          })
const RegisterRoute = RegisterRouteImport.update({
            id: '/register',path: '/register',getParentRoute: () => rootRouteImport
          })
const PrivateProductsRoute = PrivateProductsRouteImport.update({
            id: '/private-products',path: '/private-products',getParentRoute: () => rootRouteImport
          })
const PrivacyPolicyRoute = PrivacyPolicyRouteImport.update({
            id: '/privacy-policy',path: '/privacy-policy',getParentRoute: () => rootRouteImport
          })
const LoginRoute = LoginRouteImport.update({
            id: '/login',path: '/login',getParentRoute: () => rootRouteImport
          })
const LivingBooksRoute = LivingBooksRouteImport.update({
            id: '/living-books',path: '/living-books',getParentRoute: () => rootRouteImport
          })
const LifepacRoute = LifepacRouteImport.update({
            id: '/lifepac',path: '/lifepac',getParentRoute: () => rootRouteImport
          })
const IntlShippingRoute = IntlShippingRouteImport.update({
            id: '/intl-shipping',path: '/intl-shipping',getParentRoute: () => rootRouteImport
          })
const ForgotPasswordRoute = ForgotPasswordRouteImport.update({
            id: '/forgot-password',path: '/forgot-password',getParentRoute: () => rootRouteImport
          })
const FaqsRoute = FaqsRouteImport.update({
            id: '/faqs',path: '/faqs',getParentRoute: () => rootRouteImport
          })
const EnrichmentClassesRoute = EnrichmentClassesRouteImport.update({
            id: '/enrichment-classes',path: '/enrichment-classes',getParentRoute: () => rootRouteImport
          })
const ContactRoute = ContactRouteImport.update({
            id: '/contact',path: '/contact',getParentRoute: () => rootRouteImport
          })
const CheckoutRoute = CheckoutRouteImport.update({
            id: '/checkout',path: '/checkout',getParentRoute: () => rootRouteImport
          })
const CartRoute = CartRouteImport.update({
            id: '/cart',path: '/cart',getParentRoute: () => rootRouteImport
          })
const BooklistRoute = BooklistRouteImport.update({
            id: '/booklist',path: '/booklist',getParentRoute: () => rootRouteImport
          })
const BjuRoute = BjuRouteImport.update({
            id: '/bju',path: '/bju',getParentRoute: () => rootRouteImport
          })
const AccountRoute = AccountRouteImport.update({
            id: '/account',path: '/account',getParentRoute: () => rootRouteImport
          })
const AboutRoute = AboutRouteImport.update({
            id: '/about',path: '/about',getParentRoute: () => rootRouteImport
          })
const IndexRoute = IndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => rootRouteImport
          })
const PSlugRoute = PSlugRouteImport.update({
            id: '/p/$slug',path: '/p/$slug',getParentRoute: () => rootRouteImport
          })
const OrderReturnRoute = OrderReturnRouteImport.update({
            id: '/order/return',path: '/order/return',getParentRoute: () => rootRouteImport
          })
const OrderIdRoute = OrderIdRouteImport.update({
            id: '/order/$id',path: '/order/$id',getParentRoute: () => rootRouteImport
          })
const AccountIndexRoute = AccountIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => AccountRoute
          })
const AccountWishlistRoute = AccountWishlistRouteImport.update({
            id: '/wishlist',path: '/wishlist',getParentRoute: () => AccountRoute
          })
const AccountProfileRoute = AccountProfileRouteImport.update({
            id: '/profile',path: '/profile',getParentRoute: () => AccountRoute
          })
const AccountOrdersRoute = AccountOrdersRouteImport.update({
            id: '/orders',path: '/orders',getParentRoute: () => AccountRoute
          })
const AccountAddressesRoute = AccountAddressesRouteImport.update({
            id: '/addresses',path: '/addresses',getParentRoute: () => AccountRoute
          })





const AccountRouteChildren = {
  AccountAddressesRoute: AccountAddressesRoute,AccountOrdersRoute: AccountOrdersRoute,AccountProfileRoute: AccountProfileRoute,AccountWishlistRoute: AccountWishlistRoute,AccountIndexRoute: AccountIndexRoute
}

const AccountRouteWithChildren = AccountRoute._addFileChildren(AccountRouteChildren)

const rootRouteChildren = {
  IndexRoute: IndexRoute,AboutRoute: AboutRoute,AccountRoute: AccountRouteWithChildren,BjuRoute: BjuRoute,BooklistRoute: BooklistRoute,CartRoute: CartRoute,CheckoutRoute: CheckoutRoute,ContactRoute: ContactRoute,EnrichmentClassesRoute: EnrichmentClassesRoute,FaqsRoute: FaqsRoute,ForgotPasswordRoute: ForgotPasswordRoute,IntlShippingRoute: IntlShippingRoute,LifepacRoute: LifepacRoute,LivingBooksRoute: LivingBooksRoute,LoginRoute: LoginRoute,PrivacyPolicyRoute: PrivacyPolicyRoute,PrivateProductsRoute: PrivateProductsRoute,RegisterRoute: RegisterRoute,ResetPasswordRoute: ResetPasswordRoute,ReturnsRoute: ReturnsRoute,SaleRoute: SaleRoute,ShippingRoute: ShippingRoute,ShopRoute: ShopRoute,TrackRoute: TrackRoute,TyndaleRoute: TyndaleRoute,VerifyEmailChangeRoute: VerifyEmailChangeRoute,OrderIdRoute: OrderIdRoute,OrderReturnRoute: OrderReturnRoute,PSlugRoute: PSlugRoute
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)